import { render, staticRenderFns } from "./skeletonSlider.vue?vue&type=template&id=4077b994&scoped=true&"
var script = {}
import style0 from "./skeletonSlider.vue?vue&type=style&index=0&id=4077b994&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077b994",
  null
  
)

export default component.exports